import data from 'data/records.json';

export const getRecords = async () => {
  const { records } = data;
  return records;
};
